import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { STATUS_OPTIONS, TYPE_LABEL } from "./inboxMeta";

const ALL = "__all";

function TypeTabs({ types, pending, type, onType }) {
  const total = Object.values(pending || {}).reduce((a, b) => a + b, 0);
  const tabs = [["all", "All", total], ...types.map((t) => [t, TYPE_LABEL[t], pending?.[t] || 0])];
  return (
    <div className="flex flex-wrap gap-1.5" data-testid="inbox-type-tabs">
      {tabs.map(([key, label, n]) => (
        <button key={key} type="button" onClick={() => onType(key)} data-testid={`inbox-type-${key}`}
                className={`border-2 border-black px-3 py-1.5 text-[10px] uppercase tracking-widest transition-colors duration-100 ${type === key ? "bg-black text-white" : "bg-white hover:bg-zinc-100"}`}>
          {label}{n > 0 && <span className={`ml-1.5 px-1 font-mono ${type === key ? "bg-amber-400 text-black" : "bg-amber-200"}`}>{n}</span>}
        </button>
      ))}
    </div>
  );
}

function Pick({ value, onChange, options, testId, label }) {
  return (
    <label className="flex min-w-0 items-center gap-2 text-[11px]">
      <span className="label-mono">{label}</span>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="h-8 w-44 rounded-none border-black text-xs" data-testid={testId}><SelectValue /></SelectTrigger>
        <SelectContent>
          {options.map(([v, l]) => <SelectItem key={v} value={v} data-testid={`${testId}-${v}`}>{l}</SelectItem>)}
        </SelectContent>
      </Select>
    </label>
  );
}

export function InboxFilters({ data, type, onType, status, onStatus, buyer, onBuyer, buyers }) {
  return (
    <div className="mb-4 space-y-3 border-2 border-black bg-white p-3" data-testid="inbox-filters">
      <TypeTabs types={data?.types || []} pending={data?.pending} type={type} onType={onType} />
      <div className="flex flex-wrap items-center gap-4">
        <Pick label="Status" value={status} onChange={onStatus} options={STATUS_OPTIONS} testId="inbox-status" />
        <Pick label="Buyer" value={buyer || ALL} onChange={(v) => onBuyer(v === ALL ? "" : v)}
              options={[[ALL, "All buyers"], ...buyers.map((b) => [b, b])]} testId="inbox-buyer" />
      </div>
    </div>
  );
}
